import Table from 'react-bootstrap/Table';
import {useTranslation} from "react-i18next";
import PlayerNameWithFlag from "../PlayerNameWithFlag";
import type {Player} from "../../../types/domain";

interface PlayerPickingTableProps {
  players: Player[];
  selectPlayer: (player: Player) => void;
}

function PlayerPickingTable(props: PlayerPickingTableProps) {
  const { t } = useTranslation();
    return (
        <Table striped bordered hover size="sm" variant="dark">
            <thead style={{"textTransform": "none"}}>
            <tr>
                <th>{t("player")}</th>
            </tr>
            </thead>
            <tbody>
            {props.players.map((player) => {
                return (
                    <tr key={player.id} onClick={() => props.selectPlayer(player)} className="clickable">
                        <th><PlayerNameWithFlag player={player} includeElo={true} notLink={true} /></th>
                    </tr>
                )
            })}
            </tbody>
        </Table>
    );
}

export default PlayerPickingTable
